module.exports = __webpack_public_path__ + "img/ly.e5a7c870.jpg";